/* @flow weak */
import * as actions from "./actions";
import { Record } from "../transit";

import Alert from "react-s-alert";

const State = Record(
  {
    error: null,
    location: null,
    menuShown: false,
    online: false,
    appLoading: 0,
    transitionResolve: null,
    transitionReject: null
  },
  "app"
);

const appReducer = (state = new State(), action) => {
  // This is how we can handle all async actions rejections.
  //if (action.type.endsWith('_ERROR')) {
  //const error = action.payload;
  //return state.set('error', error);
  //}

  switch (action.type) {
    case actions.APP_OFFLINE:
      return state.set("online", false);

    case actions.APP_ONLINE:
      return state.set("online", true);

    case actions.APP_SET_LOCATION:
      return state.set("location", action.payload.location);

    case actions.APP_SHOW_MENU:
      return state.set("menuShown", action.payload.show);

    case actions.APP_ERROR: {
      Alert.error(action.payload, {
        position: "bottom",
        timeout: 3000
      });
      return state;
    }

    case actions.INCREASE_LOADING:
      return state.set("appLoading", state.get("appLoading") + 1);

    case actions.DECREASE_LOADING:
      return state.set("appLoading", state.get("appLoading") - 1);

    case actions.TRANSITION_BLOCK: {
      const { resolve, reject } = action.payload;

      return state
        .set("transitionResolve", resolve)
        .set("transitionReject", reject);
    }

    case actions.CONFIRM_TRANSITION: {
      state.transitionResolve(true);
      return state.set("transitionResolve", null).set("transitionReject", null);
    }

    case actions.REJECT_TRANSITION: {
      state.transitionReject(false);
      return state.set("transitionResolve", null).set("transitionReject", null);
    }

    default:
      return state;

  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/common/app/reducer.js